import WorkflowBuilderSidePanelTypeField from '../WorkflowBuilderSidepanelFields/WorkflowBuilderSidePanelTypeField'

export const WorkflowBuilderBlockMisc = () => (
  <div className="flex flex-col">
    <WorkflowBuilderSidePanelTypeField />
  </div>
)

export default WorkflowBuilderBlockMisc
